"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_cloud__download__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "86da3a62-87b6-41b9-a261-4d7823a3c3f6",
    x1: 87.28,
    y1: 87.62,
    x2: 134.63,
    y2: 134.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "554e447b-e44c-4bf5-8535-707b6b93acf0",
    "data-name": "Cloud_download_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,85.25a38.91,38.91,0,0,0-48.64-37.51A45.17,45.17,0,0,0,39.3,56.46,34.74,34.74,0,0,0,50.86,124h86.52A38.81,38.81,0,0,0,176,85.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,122H50.86A34.8,34.8,0,0,1,16,88.13c0,.37,0,.74,0,1.12A34.8,34.8,0,0,0,50.86,124h86.52A38.81,38.81,0,0,0,176,85.25c0-.33,0-.67,0-1A38.8,38.8,0,0,1,137.38,122Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.39,75.5,99.28,124h38.1a39,39,0,0,0,9.44-1.22Z",
    opacity: 0.2,
    fill: "url(#86da3a62-87b6-41b9-a261-4d7823a3c3f6)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 78.5,
    x2: 96.99,
    y2: 172.02,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "122.99 144.02 96.99 172.02 70.99 144.02",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.92,144.74l-26,28a4,4,0,0,1-5.86,0l-26-28a4,4,0,0,1-.93-1.74,4,4,0,0,0,.93,3.74l26,28a4,4,0,0,0,5.86,0l26-28a4,4,0,0,0,.93-3.74A4,4,0,0,1,125.92,144.74Z",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }))), /*#__PURE__*/React.createElement("title", null, "cloud-download-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "d28e886c-dcdd-43eb-b2a4-e12d6b9dbed7",
    "data-name": "Cloud_download_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "48d20a7b-8837-4e32-bb82-7c1691452076",
    "data-name": "Cloud_download_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#554e447b-e44c-4bf5-8535-707b6b93acf0"
  })));
}

var _default = ic_cloud__download__dark;
exports.default = _default;